<template>
    <div
        style    = "margin-left: 75px;"
        :style   = "showTitle ? ' width: calc(100% - 75px)' : ''"
        v-resize = "onResize"
        @dragover.prevent
        @drop.prevent
    >
        <d-inbox-customer
            v-model      = "editCustomer"
            :customer-id = "customerId"
        />

        <d-inbox-detail
            v-model     = "zoom"
            :attachment = "attachment.data"
            :height     = "height+70"
            @close      = "onClose"
            @morph      = "onMorph"
            @changed    = "onDChanged"
            @context    = "onDContext"
            @create     = "onCreate"
            @creategoto = "onCreateAndGoto"
        />

        <d-import-confirm
            v-model     = "confirm.show"
            :messages   = "confirm.messages"
            :files      = "confirm.files"
            @uploaded   = "onForceUploaded"
        />

        <d-upload-type-select
            v-model   = "typeSelect.show"
            :files    = "typeSelect.files"
            @confirm  = "onTypeConfirmed"
            @cancel   = "onTypeCancelled"
        />

        <c-app-bar
            v-if           = "showTitle"
            title          = "INBOX"
            :categories    = "[]"
            :enable-search = "false"
        >
            <template slot="search">
                <c-toolbar-button
                    icon     = "mdi-home"
                    color    = "primary"
                    :size    = "22"
                    :tooltip = "$t('home.button')"
                    class    = "ml-2"
                    @click   = "onLiftmanagement"
                />
                <v-spacer />
            </template>
        </c-app-bar>

        <c-customer-index
            :minimize           = "false"
            :enable-search      = "true"
            :filter-height      = "175"
            :pre-index-height   = "34"
            :show-misc          = "false"
            :show-unref-filter  = "false"
            :show-tags          = "false"
            @changed            = "onCustomer"
            ref                 = "index"
            :style              = "showTitle ? 'padding-right: 75px;' : ''"
        >
            <template v-slot:flags="{ item }">
                <div style="margin-top: -4px;" class="pr-1" v-if="customerId === item.id">
                    <c-toolbar-button
                        color    = "primary"
                        size     = "24"
                        icon     = "mdi-pencil-box-outline"
                        :tooltip = "$t('inb.overview.customer.edit')"
                        @click   = "onEditCustomer(item)"
                    />
                </div>
                <c-inbox-quality :item = "item" />
            </template>

            <template v-slot:pre-index>
                <v-row
                    dense
                    class  = "primary-border pl-2 mt-1 mb-1 v-flex"
                    :class = "customerId === 'all' ? 'unknown-selected' : ''"
                    style  = "margin-right: 14px!important; height: 30px; padding-top: 3px; border-radius: 4px;"
                >
                    <a
                        @click="onAll"
                        class="w-100"
                    >
                        <div class="v-flex">
                            <div>
                                {{ $t('inb.overview.customer.all') }}
                            </div>
                            <v-spacer />
                            <c-inbox-quality :all-mode="true" />
                        </div>
                    </a>
                </v-row>
                <v-row
                    dense
                    class  = "primary-border pl-2 mt-1 mb-3 v-flex"
                    :class = "customerId === 0 ? 'unknown-selected' : ''"
                    style  = "margin-right: 14px!important; height: 30px; padding-top: 3px; border-radius: 4px;"
                >
                    <a
                        @click="onUnknown"
                        class="w-100"
                    >
                        <div class="v-flex">
                            <div>
                                {{ $t('inb.overview.customer.without') }}
                            </div>
                            <v-spacer />
                            <c-inbox-quality :item = "null" />
                        </div>
                    </a>
                </v-row>
            </template>

            <template v-slot:detail="{  }">
                <div
                    @drop      = "onDrop"
                    @dragleave = "fileDragOut"
                    @dragover  = "fileDragIn"
                    class      = "w-100 h-100"
                    :class     = "drag ? 'drop-allowed' : ''"
                >
                    <div
                        v-if  = "customerId || customerId === 0"
                        class = "v-flex"
                    >
                        <div style="width: 33.3%;">
                            <c-inbox-filter
                                @expand   = "onFilterExpanded"
                                @changed  = "onFilter"
                                @reload   = "onReload"
                                :text     = "search"
                                :messages = "data"
                                :all-mode = "customerId === 'all'"
                                ref       = "filter"
                            />

                            <div class=""
                                :style="'max-height: ' + scrollHeight + 'px; ' + 'height: ' + scrollHeight + 'px'"
                            >
                                <virtual-scroller
                                    ref        = 'scroller'
                                    :items     = "filteredMessages"
                                    key-field  = "id"
                                    :prerender = "2"
                                    :style     = "'max-height: ' + scrollHeight + 'px; ' + 'height: ' + scrollHeight + 'px'"
                                    style      = "width: calc(100% + 0px); overflow-y: scroll"
                                >
                                    <div slot-scope="{ item }">
                                        <c-import
                                            :item     = "item"
                                            :selected = "attachment.data"
                                            class     = "import-card"
                                            @selected = "onSelected"
                                        />
                                    </div>
                                </virtual-scroller>
                            </div>
                        </div>
                        <div class="ml-1 mt-0 pl-4 message-block"
                             :style = "panelHeight"
                        >
                            <div style="position: absolute; right: 1px; top: 15px; z-index: 10">
                                <c-inbox-attachment-menu
                                    :attachment = "attachment.data"
                                    :save-allowed = "tab === 1"
                                    @save       = "onSave"
                                    @ignore     = "onIgnore"
                                    @confirmed  = "onConfirmend"
                                    @refresh    = "onRefreshAttachment"
                                    @zoom       = "onZoom"
                                    @close      = "onClose"
                                    @create     = "onCreate"
                                    @creategoto = "onCreateAndGoto"
                                />
                            </div>

                            <div 
                                v-if="!attachment.data"
                                class="drop-zone-hint"
                            >
                                <div class="drop-zone-content">
                                    <v-icon size="80" color="grey lighten-1">mdi-cloud-upload-outline</v-icon>
                                    <div class="mt-4 text-h6 grey--text text--darken-1">
                                        {{ $t('inb.upload.hint') }}
                                    </div>
                                    <div class="mt-2 grey--text">
                                        {{ $t('inb.upload.subtitle') }}
                                    </div>
                                </div>
                            </div>

                            <v-tabs
                                v-if="attachment.data"
                                v-model      = "tab"
                                class        = "mt-3 folder-tabs ml-0 mr-0 pr-0"
                                active-class = "folder-tab-active primary"
                                height       = "30"
                                style        = "height: calc(100% - 20px)"
                                light
                            >
                                <v-tabs-slider color="primary"></v-tabs-slider>
                                <v-tab
                                    class="folder-tab"
                                    :key="1"
                                >
                                    Mail / Anhang
                                </v-tab>
                                <v-tab
                                    class="folder-tab"
                                    :key="2"
                                >
                                    Inhalt
                                </v-tab>

                                <v-tabs-items
                                    v-model="tab"
                                    class="mt-1"
                                    style="height: calc(100% - 40px);"
                                    active-class="xxx"
                                >
                                    <v-tab-item :key="1" style="height: 100%">
                                        <c-dms-viewer
                                            :document = "attachment.data.dmsId"
                                        />
                                    </v-tab-item>

                                    <v-tab-item :key="2" class="h-100">
                                        <c-inbox-detail
                                            :attachment = "attachment.data"
                                            @context    = "onContext"
                                            @changed    = "onChanged"
                                            @morph      = "onMorph"
                                            :height     = "height"
                                            ref         = "message"
                                            :key        = "refreshDetail"
                                        />
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </div>
                    </div>
                </div>
            </template>
        </c-customer-index>
    </div>
</template>

<script>

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import Core                 from "@/modules/core/service/Core";
import Inb                  from "@/modules/inb/service/Inb";
import Inc                  from "@/modules/inc/service/Inc";
import CCustomerIndex       from "@/modules/msd/company/customer/components/controlls/CCustomerIndex";
import CAppBar              from "@/modules/core/components/app/CAppBar";
import CImport              from "@/modules/inb/components/controlls/CImport";
import CInboxFilter         from "@/modules/inb/components/controlls/CInboxFilter";
import CInboxAttachmentMenu from "@/modules/inb/components/controlls/CInboxAttachmentMenu";
import CInboxQuality        from "@/modules/inb/components/controlls/CInboxQuality";
import CToolbarButton       from "@/modules/core/components/utils/CToolbarButton";
import DInboxCustomer       from "@/modules/inb/components/main/DInboxCustomer";
import CInboxDetail         from "@/modules/inb/components/main/details/CInboxDetail";
import DInboxDetail         from "@/modules/inb/components/main/details/DInboxDetail";
import DImportConfirm       from "@/modules/inb/components/controlls/DImportConfirm";
import DUploadTypeSelect    from "@/modules/inb/components/controlls/DUploadTypeSelect";
import CDmsViewer           from "@/modules/dms/viewer/CDmsViewer.vue";

export default {
    name: "MInbox",

    components: {
        CDmsViewer,
        DUploadTypeSelect,
        DImportConfirm,
        DInboxDetail,
        CInboxDetail,
        DInboxCustomer,
        CToolbarButton,
        CInboxQuality,
        CInboxAttachmentMenu,
        CInboxFilter,
        CImport,
        CAppBar,
        CCustomerIndex,
    },

    props: {
        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        dialog: false,
        siteId: null,
        customerId: null,
        data : [],
        attachment: {
            data     : null,
            component: null
        },

        flip: false,
        drag: false,
        height: null,
        customerCounts: [],
        filteredMessages: [],
        search: null,
        filterExpanded: false,
        tab: 0,
        refreshQuality: 0,
        editCustomer: false,
        refreshMenu: 0,
        zoom: false,
        refreshDetail: 0,
        confirm: {
            show: false,
            messages: [],
            files: []
        },
        typeSelect: {
            show: false,
            files: null
        },
        pendingUploadType: null,
    }),

    computed: {
        imports () {
            return this.data;
        },

        isAssessment () {
            return this.isType(2);
        },

        isInvoice () {
            return this.isType(4);
        },

        isIncident () {
            return this.isType(3);
        },

        isMaintenance () {
            return this.isType(5);
        },

        isDefault () {
            return this.isType(1);
        },

        scrollHeight () {
            if (!this.filterExpanded) {
                return this.height+10;
            }

            return this.height - 240;
        },

        panelHeight () {
            const height = this.height + 60;
            return 'max-height: ' + height + 'px; ' + 'height: ' + height + 'px';
        },

        hasInProgressStatus () {
            return !!(this.attachment.data && this.attachment.data.adpStatus === 'IN_PROGRESS');
        },
    },

    mounted() {
        this.onResize();
        this.refreshCounts();
        this.refreshMenu ++;

        this.$nextTick(() => {
            this.handleRouteQuery();
        });
    },

    watch: {
        tab () {
            console.log("tab", this.tab)
        },

        '$route.query' () {
            if (!this._ignoreNextRouteWatch) {
                this.handleRouteQuery();
            }
            this._ignoreNextRouteWatch = false;
        },

        hasInProgressStatus (inProgress) {
            if (inProgress) {
                this.startAdpPolling();
            } else {
                this.stopAdpPolling();
            }
        },
    },

    beforeDestroy () {
        this.stopAdpPolling();
    },

    methods: {
        refresh () {
            this.$nextTick(() => {
                this.$refs.index.onFilter();
            })
        },

        startAdpPolling () {
            if (this._adpPollTimer) return;
            this._adpPollTimer = setInterval(() => {
                if (this.attachment.data && this.attachment.data.adpStatus === 'IN_PROGRESS') {
                    Inb.load(this, this.attachment.data.id, (data) => {
                        this.attachment.data = data;
                        this.$bus.$emit(Inb.event.attachment, data);
                    });
                }
            }, 5000);
        },

        stopAdpPolling () {
            if (this._adpPollTimer) {
                clearInterval(this._adpPollTimer);
                this._adpPollTimer = null;
            }
        },

        handleRouteQuery () {
            if (this.$route.query.importId) {
                this.openDeepLink();
            } else if (this.$route.query.customerId === 'all') {
                this.openAllDeepLink();
            } else if (this.$route.query.customerId !== undefined) {
                this.openCustomerDeepLink();
            } else {
                this.onUnknown();
            }
        },

        openAllDeepLink () {
            this.$refs.index.setCustomer(null);
            this.loadImports('all');
        },

        openDeepLink (importId, customerId) {
            const id  = importId   !== undefined ? importId   : Number(this.$route.query.importId);
            const cid = customerId !== undefined ? customerId : (this.$route.query.customerId !== undefined
                ? Number(this.$route.query.customerId)
                : null);

            Inb.load(this, id, (data) => {
                this.attachment.data      = data;
                this.attachment.component = null;
                this.refreshDetail++;

                const resolvedCid = cid !== null ? cid : (data.customer ? data.customer.id : 0);
                const customer    = resolvedCid === 0 ? null : (data.customer || { id: resolvedCid });

                this.$nextTick(() => {
                    this.$refs.index.setCustomer(customer);
                    this.loadImports(resolvedCid);
                });
            });
        },

        openCustomerDeepLink () {
            const customerId = Number(this.$route.query.customerId);
            const customer   = customerId === 0 ? null : { id: customerId };

            this.$refs.index.setCustomer(customer);
            this.loadImports(customerId);
        },

        onCustomer (customer) {
            this.refreshCounts();
            this.clearDetail();

            if (!customer && customer !== 0) {
                this.customerId = null;
                this._ignoreNextRouteWatch = true;
                this.$router.replace({ query: {} }).catch(() => {});
                return;
            }

            this._ignoreNextRouteWatch = true;
            this.$router.replace({ query: { customerId: String(customer.id) } }).catch(() => {});
            this.loadImports(customer.id);
        },

        onAll () {
            this.$refs.index.setCustomer(null);
            this.refreshCounts();
            this.clearDetail();

            if (this.customerId === 'all') {
                this.customerId = null;
                this._ignoreNextRouteWatch = true;
                this.$router.replace({ query: {} }).catch(() => {});
                return;
            }

            this._ignoreNextRouteWatch = true;
            this.$router.replace({ query: { customerId: 'all' } }).catch(() => {});
            this.loadImports('all');
        },

        onUnknown () {
            this.$refs.index.setCustomer(null)
            this.refreshCounts();
            this.clearDetail();

            if (this.customerId === 0) {
                this.customerId = null;
                this._ignoreNextRouteWatch = true;
                this.$router.replace({ query: {} }).catch(() => {});
                return;
            }

            this._ignoreNextRouteWatch = true;
            this.$router.replace({ query: { customerId: '0' } }).catch(() => {});
            this.loadImports(0);
        },

        onSelected (event) {
            if (!event.data) {
                this.clearDetail();
                this._ignoreNextRouteWatch = true;
                this.$router.replace({
                    query: this.customerId !== null ? { customerId: String(this.customerId) } : {}
                }).catch(() => {});
                return;
            }

            this._ignoreNextRouteWatch = true;
            this.$router.replace({
                query: { importId: String(event.data.id), customerId: String(this.customerId) }
            }).catch(() => {});

            Inb.load(this, event.data.id, (data) => {
                this.attachment.data      = data;
                this.attachment.component = event.component;
                this.refreshDoc++;
            });
        },

        onClose () {
            this.$emit("close")  ;
        },

        fileDragIn(){
            this.drag = true;
        },

        fileDragOut() {
            this.drag = false;
        },

        onDrop(e) {
            this.drag = false;
            let droppedFiles = e.dataTransfer.files;
            if(!droppedFiles || droppedFiles.length === 0) {
                return;
            }

            this.typeSelect.files = droppedFiles;
            this.typeSelect.show  = true;
        },

        onTypeConfirmed (type) {
            this.pendingUploadType = type;
            const files = this.typeSelect.files;
            this.typeSelect.files = null;

            Inb.uploadFiles(this, files, false).then((data) => {
                this.uploadDone(files, data);
            }).catch((error) => {
                console.log(error)
            });
        },

        onTypeCancelled () {
            this.typeSelect.files = null;
        },

        onFilterExpanded (value) {
            this.filterExpanded = value;
        },

        onFilter (messages) {
            this.filteredMessages = messages;
        },

        onReload () {
            if (this.customerId === null) {
                return;
            }

            this.loadImports(this.customerId);
        },

        onZoom (value) {
            this.$nextTick(() => {
                this.tab = 1;
            })

            this.zoom = value;
        },

        onSave (callback) {
            console.log(this.$refs)
            this.$refs.message.save ((attachment) => {
                this.refreshCounts();
                this.$bus.$emit(Inb.event.attachment, attachment);
                console.log("save", attachment)
                this.attachment.data = attachment;
                this.$nextTick(() => {
                    this.refreshMenu ++;
                    this.refreshCounts ();
                    if (callback) callback();
                })
            });
        },

        onMorph (event) {
            Inb.morph(this, this.attachment.data, event.id).then((data) => {
                Inb.load(this, data.id, (freshData) => {
                    this.attachment.data = freshData;
                    this.$bus.$emit(Inb.event.attachment, freshData);
                    this.$nextTick(() => {
                        this.refreshMenu++;
                    });
                });
            });
        },

        onCreate () {
            this.onSave(() => {
                Inb.create(this, this.attachment.data.id, this.$t("inb.loading.create")).then ((data) => {
                    this.attachment.data.confirmed = true;
                    this.attachment.data.incidentId = data;
                    this.onRefreshAttachment (this.attachment.data.id);
                    this.$bus.$emit(Inb.event.refresh);
                });
            })
        },

        onCreateAndGoto () {
            this.onSave(() => {
                this.$emit("close");
                Inb.create(this, this.attachment.data.id, this.$t("inb.loading.create")).then ((data) => {
                    this.attachment.data.incidentId = data;
                    this.$bus.$emit(Inb.event.refresh);
                    this.$nextTick(() => {
                        Inc.goto(this, data);
                    })
                });
            });
        },

        onContext () {
            this.onSave(() => {
                this.$bus.$emit(Inb.event.refresh);
            });
        },

        onChanged () {
            this.onSave(() => {
                this.$bus.$emit(Inb.event.refresh);
            });
        },

        onDChanged (item) {
            this.attachment.data = item;
            this.onChanged();
        },

        onDContext (item) {
            this.attachment.data = item;
            this.onContext();
        },

        onResize () {
            this.height = window.innerHeight-140;
        },

        onEditCustomer () {
            this.editCustomer = true;
        },

        onRefreshAttachment (attachmentId) {
            Inb.load(this, attachmentId, (attachment) => {
                this.$bus.$emit(Inb.event.attachment, attachment);
                this.attachment.data = attachment;
                this.$nextTick(() => {
                    this.refreshMenu ++;
                    this.refreshDetail ++;
                })
            })
        },

        onLiftmanagement () {
            Core.nav.home(this);
        },

        loadImports (customerId) {
            this.customerId = customerId;

            // Debounced: rapid successive filter/customer changes (HCIT-802) would otherwise
            // each fire their own /api/inbox/imports + counts request, piling up overlapping
            // backend calls. $refs.filter.getFilter() is read when the timer fires, so this
            // still picks up the latest filter state, not a stale snapshot from call time.
            clearTimeout(this._loadImportsTimer);
            this._loadImportsTimer = setTimeout(() => {
                this.$nextTick(() => {
                    if (!this.$refs.filter) {
                        return;
                    }

                    const filter        = this.$refs.filter.getFilter();
                    const apiCustomerId = customerId === 'all' ? null : customerId;

                    Inb.imports(this, {
                        customerId : apiCustomerId,
                        confirmed  : filter.confirmed,
                        deleted    : filter.removed,
                        unconfirmed: filter.unconfirmed,
                        lastDay    : filter.lastDay
                    }).then ((data) => {
                        this.computeSize(data);
                        this.data = data;
                        this.refreshCounts();
                    })
                });
            }, 250);
        },


        clearDetail () {
            this.attachment.data = null;
            this.attachment.component = null;
            this.mail = null;
            this.pdfurl = null;
        },

        computeSize (data) {
            data.forEach (d => {
                switch (d.type.id) {
                    case 'MANUAL':
                        d.size = 60 + 42;
                        break;
                    case 'EMAIL':
                        d.size = Inb.message.height(false, d.messages.length);
                        break;
                }
            });
        },

        refreshCounts () {
            this.$store.dispatch("loadCustomerQualityCounts");
        },

        onConfirmend () {
            this.refreshCounts ();
        },

        onIgnore () {
            this.refreshCounts ();
        },

        isType (type) {
            return this.attachment.data && this.attachment.data.dtype === type;
        },

        onForceUploaded ({ files, messages }) {
            this.uploadDone(files, messages);
        },

        forceUpload (file) {
            Inb.upload(this, file, true).then (data => {
                this.uploadDone(data);
            }).catch((message) => {
                Core.message.popup(this, message.id, message.parameter);
            })
        },

        uploadDone (files, messages) {
            const forceMessages = [];
            const forceFiles    = [];
            const toMorph       = [];
            let   firstMessage  = null;
            let   customer      = null;

            messages.forEach((message, index) => {
                if (!customer && message.customer) {
                    customer = message.customer;
                }

                if (message.ignore) {
                    forceMessages.push(message);
                    forceFiles.push(files[index]);
                    return;
                }

                if (!firstMessage) {
                    firstMessage = message;
                }

                if (this.pendingUploadType && message.messages) {
                    message.messages.forEach((item) => {
                        if (!item.type || item.type.id !== this.pendingUploadType.id) {
                            toMorph.push(item);
                        }
                    });
                }
            });

            const finish = () => {
                if (forceMessages.length > 0) {
                    if (customer) {
                        this.$nextTick(() => {
                            this.$refs.index.setCustomer(customer);
                            this.onCustomer(customer);
                        });
                    } else {
                        this.$nextTick(() => {
                            this.$refs.index.setCustomer(null);
                            this.onUnknown();
                        });
                    }
                    this.confirm.messages = forceMessages;
                    this.confirm.files    = forceFiles;
                    this.confirm.show     = true;
                } else if (firstMessage && firstMessage.messages && firstMessage.messages[0]) {
                    const customerId = firstMessage.customer ? firstMessage.customer.id : 0;
                    const messageId  = firstMessage.messages[0].id;
                    this._ignoreNextRouteWatch = true;
                    this.$router.push({
                        name : 'imports',
                        query: { importId: String(messageId), customerId: String(customerId) }
                    }).catch(() => {});
                    this.openDeepLink(messageId, customerId);
                } else {
                    this.refreshCounts();
                    this.$bus.$emit(Inb.event.refresh);
                }
            };

            if (toMorph.length > 0) {
                // Batch: morph every item silently (each PUT still goes out individually - there's
                // no bulk-morph backend endpoint), then emit exactly one refresh for the whole
                // batch instead of one per item. With 100 uploaded documents needing a type
                // correction, the per-item emit used to fire ~100 concurrent refreshes (each
                // triggering its own nav-badge count refetch), causing the reported performance
                // problems - see HCIT-802.
                Promise.all(toMorph.map(item => Inb.morph(this, item, this.pendingUploadType.id, true))).then(() => {
                    this.$bus.$emit(Inb.event.refresh);
                    finish();
                });
            } else {
                finish();
            }
        }
    }
}

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

.import-card {
    margin-left: 16px;
    margin-right: 4px;
}

.message-block {
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: black;
    height: 100%;
    width: calc(66.7% - 4px);
}

.drop-zone-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.drop-zone-content {
    text-align: center;
    padding: 40px;
}

.drop-allowed {
    background-color: rgba(33, 150, 243, 0.08);
    border: 2px dashed #2196F3;
    border-radius: 8px;
}

.drop-allowed .drop-zone-hint {
    background-color: rgba(33, 150, 243, 0.05);
}

.drop-allowed .drop-zone-content {
    transform: scale(1.05);
    transition: transform 0.2s ease;
}

.drop-allowed .v-icon {
    color: #2196F3 !important;
}

.drop-allowed .grey--text {
    color: #2196F3 !important;
}

.folder-tab {
    border-bottom-width: 1px;
}

.xxx {
    height: 100%;
}

::v-deep .v-window__container {
    height: 100%;
}

::v-deep .search .v-input__slot {
    min-height: 35px!important;
}

::v-deep .search .v-input__append-inner {
    margin-top: 5px!important;
}

</style>

<style lang="scss" scoped>

.unknown-selected {
    color: var(--v-primary-base);
    background-color: #f0f0f0;
}

</style>